import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import {
    Divider,
    Row,
    Col,
    Button,
    Collapse,
    Spin,
    Modal,
    Tabs,
    Radio,
    List
} from 'antd';
import CurrencyInput from 'react-currency-input';
import UserProvider from '../../js/userProvider';
import Utils from  '../../js/utils';
import DataService from '../../Components/Data';
import Despesas from '../../Components/Despesas/Despesas';
import PagarDespesa from '../../Components/PagarDespesa/PagarDespesa';
import './MinhaCarteira.css';

const Panel = Collapse.Panel;
const { TabPane } = Tabs;

class MinhaCarteira extends Component {

    constructor(props) {
        super(props);

        let historico = [];
        let contas = [];

        this.state = {
            modalVisible: false,
            historico: historico,
            contas: contas,
            simboloMoeda: "",
            operacao: "",
            saldoDisponivel: "0,00",
            opcoes: [],
            amount: "0,00",
            buscando: true,
            buscandoTransferencia: false,
            buscandoDetalhes: false,
            buscandoDetalhesContas: false,
            detalhesMovimento: "",
            detalhesContas: "",
            activeKeyContas: 0,
            modalDespesaVisible: false,
            modalPagaDespesaVisible: false,
            cdTituloSelecionado: 0,
            cdTipoConta: 1
        };

        this.dataService = new DataService();
        this.utils = new Utils();
        this.dadosProvider = UserProvider.getInstance();
        this.tipoTransferencia = "";
        this.usuario = this.dadosProvider.getDadosUsuario();
    }

    componentWillMount() {
        this.getSaldo();
        this.opcoesTransacao();
        this.getMovimento();
        this.getCarteiraTitulo(1);

        this.setState({simboloMoeda: this.usuario.DsMoedaPadrao});
    }

    getCarteiraTitulo(cdTipoConta){
        this.setState({ buscando: true, activeKeyContas:[] });
        
        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto,
            "nrColOrder": "",
            "dsColOrder":"",
            "nrInicial":"",
            "cdStatus":cdTipoConta
        };
        
        this.dataService.GetCarteiraTitulo(dados, (retorno) => {
            var newData = [];

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    newData.push({
                        CdTitulo: dado['CdTitulo'],
                        CdDocumento: dado['CdDocumento'],
                        DsTipoDocumentoFinanceiro: dado['DsTipoDocumentoFinanceiro'],
                        DsReferencia: dado['DsReferencia'],
                        DtEmissao: dado['DtEmissao'],
                        DtVencimento: dado['DtVencimento'],
                        VlBruto: dado['VlBruto'],
                        VlLiquido: dado['VlLiquido'],
                        VlLiquidoRef: dado['VlLiquidoRef'],
                        CrStatus: dado['CrStatus'],
                        DsStatus: dado['DsStatus'],
                        StVencido: dado['StVencido'],
                        detalhes: ""
                    });
                }
            }

            this.setState({ contas: newData, buscando: false});            

        }, (erro) => {
            console.log(erro);
            this.setState({ buscando: false });
        });
    }

    getSaldo() {

        this.setState({ buscando: true });

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto
        };

        this.dataService.GetSaldo(dados, (retorno) => {
           
            var saldo = "0.00";
            if(retorno["VlSaldoDisponivel"] != "" && retorno["VlSaldoDisponivel"] != undefined){
                saldo = retorno["VlSaldoDisponivel"];
            }

            this.setState({ saldoDisponivel: saldo, buscando: false});            

        }, (erro) => {
            console.log(erro);
            this.setState({ buscando: true });
        });
    }

    getMovimento() {

        this.setState({ buscando: true });

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto
        };

        this.dataService.GetCarteiraMovimento(dados, (retorno) => {
            
            var newData = [];

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    newData.push({
                        DtOperacao: dado['DtOperacao'],
                        DsMovimento: dado['DsMovimento'],
                        DsComplemento: dado['DsComplemento'],
                        VlCredito: dado['VlCredito'],
                        VlDebito: dado['VlDebito'],
                        DsMoviDtLiberacaomento: dado['DtLiberacao'],
                        CdTitulo: dado['CdTitulo'],
                        tipo: (dado['VlCredito'] != ".") ? 1 : 2,
                        valor: (dado['VlCredito'] != ".") ? dado['VlCredito'] : dado['VlDebito'],
                        detalhes: ""
                    });
                }
            }

            this.setState({ historico: newData });

        }, (erro) => {
            console.log(erro);
            this.setState({ buscando: true });
        });
    }

    opcoesTransacao() {

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto
        };

        this.dataService.GetCarteiraTransferenciaConta(dados, (retorno) => {

            var newData = [];

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    newData.push({
                        CdCarteiraContaTransferencia: dado['CdCarteiraContaTransferencia'],
                        DsConta: dado['DsConta']
                    });
                }
            }

            this.setState({ opcoes: newData });

        }, (erro) => {
            console.log(erro)
        });
    }

    showModal = (opcao) => {

        this.tipoTransferencia = opcao.CdCarteiraContaTransferencia

        this.setState({
            modalVisible: true,
            operacao: opcao.DsConta,
            amount: "0,00"
        });
    }

    showModalDespesa = ()=>{
        this.setState({
            modalDespesaVisible: true
        })
    }

    solicitarCredito = (valor) => {

        if (valor === "0,00" || valor === 0 || valor === "0" || valor === 0.00 || valor === "0.00") {
            //alert("Selecione o valor");
            Modal.error({
                title: 'Erro',
                content: 'Selecione o valor',
            });
        } else {
            this.getTaxa(valor);
        }

    }

    solicitarCreditoTotal = () => {
        var valor = this.state.saldoDisponivel.replace(",", ".");
        this.getTaxa(valor);
    }

    getTaxa(valor) {
        this.setState({ buscandoTransferencia: true });

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto,
            "vlTransferencia": valor,
            "cdCarteiraContaTransferencia": this.tipoTransferencia
        };

        this.dataService.GetTransferenciaTaxa(dados, (retorno) => {            

            if (retorno.Status === "1") {
                var taxa = retorno.VlTaxa;
                if (taxa != "") {
                    taxa = parseFloat(taxa);

                    var self = this;

                    Modal.confirm({
                        title: 'Confirme o valor',
                        content: (<div>
                            <p>Valor solicitado: {this.state.simboloMoeda} {valor}<br />
                                Taxa: {(taxa == 0) ? ("Isento") : (`-${this.state.simboloMoeda} `+ taxa)}<br />
                                Valor a ser creditado: {this.state.simboloMoeda} {(valor - taxa).toFixed(2)}</p>
                            <p>Confirma a transferência?</p>
                        </div>),
                        onOk() {
                            self.solicitarTransferencia(valor);
                        },
                        onCancel(){
                            self.setState({ buscandoTransferencia: false });
                        }
                    });
                }
            } else {
                this.setState({ buscandoTransferencia: false });
                //this.solicitarTransferencia(valor);
                Modal.error({
                    title: 'Erro',
                    content: retorno.Msg,
                });
            }

        }, (erro) => {
            console.log(erro);
            this.setState({ buscandoTransferencia: false });
        });
    }

    solicitarTransferencia(valor) {

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto,
            "vlTransferencia": valor,
            "cdCarteiraContaTransferencia": this.tipoTransferencia
        };

        this.dataService.TransfereSaldo(dados, (retorno) => {

            this.setState({ buscandoTransferencia: false });

            if (retorno.Status === "1") {
                this.getSaldo();
                this.setState({
                    modalVisible: false,
                    amount: "0,00",
                    historico: []
                });
                Modal.success({
                    title: 'Sucesso',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)                    
                });
                this.getMovimento();

            } else {
                Modal.error({
                    title: 'Erro',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)
                });
            }

        }, (erro) => {
            console.log(erro);
            this.setState({ buscandoTransferencia: false });
        });
    }

    handleCancel = (e) => {
        this.setState({
            modalVisible: false,
        });
    }

    handleCancelDespesa = (stReload) => {
        this.setState({
            modalDespesaVisible: false,
        });

        this.handleCancelPagarDespesa(stReload);
    }

    handleCancelPagarDespesa = (stReload = false) => {
        this.setState({
            modalPagaDespesaVisible: false
        });

        if(stReload)
            this.getCarteiraTitulo(this.state.cdTipoConta);
    }

    handleChange = (event, maskedvalue, floatvalue) => {
        this.setState({ amount: floatvalue });
    }

    getDetalhesContas = (index) => {
        this.setState({ activeKeyContas: index });

        if (index != undefined) {
            let conta = this.state.contas[index];

            if (conta.detalhes == "" && conta.CdTitulo != "0") {
                this.buscaDetalhesConta(conta, index);
            } else {
                this.setState({ detalhesContas: conta.detalhes });
            }
        }
    }
    
    getDetalhes = (index) => {

        if (index != undefined) {
            let historico = this.state.historico[index];

            if (historico.detalhes == "" && historico.CdTitulo != "0") {
                this.buscaDetalhes(historico, index);
            } else {
                this.setState({ detalhesMovimento: historico.detalhes });
            }
        }
    }

    buscaDetalhes(historico, index) {

        this.setState({ buscandoDetalhes: true, detalhesMovimento: "" });

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto,
            "cdTitulo": historico.CdTitulo
        };

        this.dataService.GetCarteiraMovimentoDet(dados, (retorno) => {

            var arrayHistorico = this.state.historico;
            var html = retorno.DsHTML;
            arrayHistorico[index].detalhes = html;
            
            this.setState({ buscandoDetalhes: false, historico: arrayHistorico, detalhesMovimento: html });

        }, (erro) => {
            console.log(erro);
            this.setState({ buscandoDetalhes: false });
        });
    }

    buscaDetalhesConta(conta, index) {

        this.setState({ buscandoDetalhesContas: true, detalhesContas: "" });

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto,
            "cdTitulo": conta.CdTitulo
        };

        this.dataService.GetCarteiraMovimentoDet(dados, (retorno) => {

            var arrayContas = this.state.contas;
            var html = retorno.DsHTML;
            arrayContas[index].detalhes = html;
            
            this.setState({ buscandoDetalhesContas: false, contas: arrayContas, detalhesContas: html });

        }, (erro) => {
            console.log(erro);
            this.setState({ buscandoDetalhesContas: false });
        });
    }

    htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    getHeader(historico) {

        const header = (
            <Row style={{width:"100%"}}>
                <Col sm={{ span: 6 }} xs={{ span: 12 }}>{historico.DtOperacao}</Col>
                <Col span={12} className="text-center textCredito">{historico.DsMovimento}</Col>
                <Col sm={{ span: 6 }} xs={{ span: 24 }} className={["text-right", (historico.tipo === 1) ? "text-green" : "text-red"].join(' ')}>{historico.valor}</Col>
            </Row>
        )

        return header
    }

    getHeaderContas = (conta) => {
        console.log(conta);
        var dtAtual = new Date();
        var dtVencimento = this.utils.GetDateFromText(conta.DtVencimento);
        
        const header = (
            <div>
                {this.state.cdTipoConta == 1 ?
                (
                    <Row className="header-flex">
                        <Col className={(dtVencimento < dtAtual && this.state.cdTipoConta < 3  ? "text-red": "")}>Vencimento: {conta.DtVencimento}</Col>
                        <Col className="text-center">{conta.DsTipoDocumentoFinanceiro}</Col>
                        <Col sm={{ span: 6 }} xs={{ span: 7 }} className="text-center">{conta.VlLiquido}</Col>
                        <Col span={3} className="text-center">                    
                            <Button type="primary" icon="shopping-cart" onClick={()=>{this.abrePagarDespesa(conta.CdTitulo)}}/>                    
                        </Col>
                    </Row>
                ) : (
                    <Row className="header-flex">
                        <Col xs={{ span: 7 }} className={(dtVencimento < dtAtual && this.state.cdTipoConta < 3 ? "text-red": "")}>Vencimento: {conta.DtVencimento}</Col>
                        <Col className="text-center">{conta.DsTipoDocumentoFinanceiro}</Col>
                        <Col sm={{ span: 6 }} xs={{ span: 7 }} className="text-right">{conta.VlLiquido}</Col>
                    </Row>
                )}                
            </div>
        )

        return header;
    }

    abrePagarDespesa = (cdTitulo) =>{
        this.setState({modalPagaDespesaVisible: true});
        this.setState({cdTituloSelecionado: cdTitulo});
    }

    // onTipoContaChange = (checked) => {
    //     console.log(checked);

    //     if(checked){
    //         this.getCarteiraTitulo(1);
    //     }else{
    //         this.getCarteiraTitulo(2);
    //     }
    // }

    onTipoContaChange = (e) => {
        this.setState({cdTipoConta: e.target.value});
        this.getCarteiraTitulo(e.target.value);
    }

    render() {

        return (
            <LayoutPages pageTitle="Minha Carteira" history={this.props.history} pageIndex="4">
                <div className="divCarteira" >

                    <Modal
                        title={this.state.operacao}
                        visible={this.state.modalVisible}
                        onCancel={this.handleCancel}
                        footer={null}
                    >
                        {this.state.modalVisible ? (
                            <div>

                                <Row className="rowSpace" justify="center">
                                    <Col className="text-center">Qual valor deseja {this.state.operacao}?</Col>
                                </Row>
                                <Row className="rowSpace" justify="center">
                                    <Col className="text-center">Saldo Disponivel: {this.state.simboloMoeda} {this.state.saldoDisponivel}</Col>
                                </Row>

                                <Row className="rowSpace" justify="center">
                                    <Col className="text-center">
                                        <span className="ant-input-group-wrapper">
                                            <span className="ant-input-wrapper ant-input-group">
                                                <span className="ant-input-group-addon">{this.state.simboloMoeda}</span>
                                                <CurrencyInput decimalSeparator="," thousandSeparator="." className="ant-input" value={this.state.amount} onChangeEvent={this.handleChange} />
                                            </span>
                                        </span>
                                    </Col>
                                </Row>

                                {this.state.buscandoTransferencia ? (
                                    <Row className="imageAguarde">
                                        <Spin /> Aguarde...
                                    </Row>
                                ) : ""}
                                <Row className="buttonRow" gutter={16}>
                                    <Col className="marginBottom" sm={{ span: 12 }} xs={{ span: 24 }}>
                                        <Button disabled={this.state.buscandoTransferencia} size="large" type="primary" onClick={() => this.solicitarCredito(this.state.amount)}>Solicitar crédito</Button>
                                    </Col>
                                    <Col sm={{ span: 12 }} xs={{ span: 24 }}>
                                        <Button disabled={this.state.buscandoTransferencia} size="large" type="primary" onClick={() => this.solicitarCreditoTotal()}>Solicitar crédito total</Button>
                                    </Col>
                                </Row>

                            </div>
                        ) : ""}
                    </Modal>

                    {/* <Modal
                        title="Adicionar Despesa"
                        visible={this.state.modalDespesaVisible}
                        onCancel={this.handleCancelDespesa}
                        footer={null}
                    >
                        
                    </Modal> */}
                    <Despesas modalVisible={this.state.modalDespesaVisible} onClose={(stReload)=>{this.handleCancelDespesa(stReload)}} saldoDisponivel={this.state.saldoDisponivel}></Despesas>
                    <PagarDespesa modalVisible={this.state.modalPagaDespesaVisible} onClose={(stReload)=>{this.handleCancelPagarDespesa(stReload)}} cdTitulo={this.state.cdTituloSelecionado}></PagarDespesa>

                    <Divider className="divider">Saldo Disponível</Divider>

                    <Row justify="center">
                        <Col className="text-center colValor">{this.state.simboloMoeda} {this.state.saldoDisponivel}</Col>
                    </Row>

                    <Row className="buttonRow" gutter={16}>
                        {this.state.opcoes
                            .map((opcao, index) =>

                                <Col key={index} className="marginBottom" sm={{ span: 12 }} xs={{ span: 24 }}>
                                    <Button onClick={() => this.showModal(opcao)} size="large" type="primary">{opcao.DsConta}</Button>
                                </Col>
                            )}
                        <Col className="marginBottom" sm={{ span: 12 }} xs={{ span: 24 }}>
                            <Button onClick={()=> this.showModalDespesa()} size="large" type="primary">Adicionar Despesa</Button>
                        </Col>
                    </Row>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Histórico da Carteira" key="1" className="teste">
                            {
                                this.state.buscando ?
                                (
                                    <div className="spinner">
                                        <Spin className="imageSpin" />
                                    </div>
                                            
                                ) : <div></div>
                            }

                            {
                                this.usuario.StOcultaCarteiraMovDet == "1" ? 
                                (
                                    <List
                                        bordered
                                        dataSource={this.state.historico}
                                        renderItem={historico => <List.Item style={{background:"white"}}>{this.getHeader(historico)}</List.Item>}
                                    />
                                )
                                :
                                (
                                    <Collapse className="collapseCarteira" accordion onChange={this.getDetalhes}>
                                        {this.state.historico.map((historico, index) =>
                                            <Panel header={this.getHeader(historico)} key={index}>
                                                <p>{(historico.DsComplemento != ".") ? historico.DsComplemento : ""}</p>
                                                {this.state.buscandoDetalhes ?
                                                    (<Row className="imageAguarde">
                                                        <Spin /> Aguarde...
                                                    </Row>)
                                                    :
                                                    (
                                                        <div>
                                                            {
                                                                this.state.detalhesMovimento != "" ? 
                                                                (
                                                                    <div>
                                                                        <strong>====== TRANSAÇÕES ======</strong>
                                                                        <div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.state.detalhesMovimento) }} />
                                                                    </div>
                                                                ) : <div></div>
                                                            }
                                                        </div>
                                                    )}
                                            </Panel>
                                        )}
                                    </Collapse>
                                )
                            }
                        </TabPane>
                        <TabPane tab="Contas" key="2">
                            {
                                this.state.buscando ?
                                (
                                    <div className="spinner">
                                        <Spin className="imageSpin" />
                                    </div>
                                            
                                ) : <div></div>
                            }
                            {/* <div className="switchContasContainer">
                                <Switch checkedChildren="A Pagar" unCheckedChildren="A Receber" defaultChecked onChange={ (e)=> {this.onTipoContaChange(e)}}/>
                            </div> */}
                            <div>
                                <Radio.Group defaultValue="1" className="tipoContaContainer" onChange={this.onTipoContaChange}>
                                    <Radio.Button value="1" className="tipoContaItem">A Pagar</Radio.Button>
                                    <Radio.Button value="2" className="tipoContaItem">A Receber</Radio.Button>
                                    <Radio.Button value="3" className="tipoContaItem">Pagas</Radio.Button>
                                    <Radio.Button value="4" className="tipoContaItem">Recebidas</Radio.Button>
                                </Radio.Group>
                            </div>
                            {this.state.buscando ?
                                (<Row>
                                    <Col className="imageRadio">
                                        <div className="divSpin">
                                            <Spin className="imageSpin" />
                                        </div>
                                    </Col>
                                </Row>) 
                                :                 
                            (
                                <Collapse className="collapseCarteira" accordion onChange={this.getDetalhesContas} activeKey={this.state.activeKeyContas}>
                                    {this.state.contas.map((conta, index) =>
                                        <Panel header={this.getHeaderContas(conta)} key={index}>
                                            {this.state.buscandoDetalhesContas ?
                                                (<Row className="imageAguarde">
                                                    <Spin /> Aguarde...
                                                </Row>)
                                                :
                                                (
                                                    <div>
                                                        <p>
                                                            <strong>>> No.Titulo: {conta.CdTitulo}</strong><br/>
                                                            Emissão: {conta.DtEmissao}<br/>
                                                            Documento: {conta.DsTipoDocumentoFinanceiro}<br/>
                                                            Cód. doc.: {conta.CdDocumento}<br/>
                                                            Referência: {conta.DsReferencia}<br/>

                                                            Valor Bruto: {conta.VlBruto}<br/>
                                                            Valor Líquido de Referência: {conta.VlLiquidoRef}<br/>
                                                        </p>
                                                        <br></br>

                                                        {
                                                            this.state.detalhesContas != "" ? 
                                                            (
                                                                <div>
                                                                    <strong>====== TRANSAÇÕES ======</strong>
                                                                    <div dangerouslySetInnerHTML={{ __html: this.htmlDecode(this.state.detalhesContas) }} />
                                                                </div>
                                                            ) : <div></div>
                                                        }
                                                    </div>
                                                )}
                                        </Panel>
                                    )}
                                </Collapse>
                            )}
                        </TabPane>
                    </Tabs>
                </div>

            </LayoutPages>
        )
    }
}

export default MinhaCarteira;


// WEBPACK FOOTER //
// ./src/Pages/MinhaCarteira/MinhaCarteira.js